/**
 * Nombres legibles para las claves de `especificaciones`. Vive fuera de los
 * componentes para no romper el Fast Refresh de Vite (un archivo de
 * componentes solo debe exportar componentes).
 */
const ETIQUETAS = {
  norma: "Norma",
  diametro: "Diametro",
  largo: "Largo",
  medida: "Medida",
  espesor: "Espesor",
  ancho: "Ancho",
  anchoUtil: "Ancho util",
  acabado: "Acabado",
  calibre: "Calibre",
  presentacion: "Presentacion",
  cocada: "Cocada",
  corte: "Corte",
  pesoUnitario: "Peso",
};

export function etiqueta(clave) {
  return ETIQUETAS[clave] || clave;
}
